export default "__VITE_ASSET__CnQ_WvVX__"